/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';

export const iconForElectricMeter = (
  EEquipmentTypes: string | undefined,
  suppliesSpatialElement: IAny,
  siteID: IAny
) => {
  const MainMeter = require(`../../images/MainMeterIcon.svg`);
  const SubMeter = require(`../../images/SubMeterIcon.svg`);
  const VirtualMeter = require(`../../images/VirtualMeter.svg`);

  if (
    EEquipmentTypes === 'ElectricMeter' &&
    suppliesSpatialElement.includes(siteID)
  ) {
    return <img className="equipment-meter-icon" src={MainMeter} />;
  } else if (
    EEquipmentTypes === 'ElectricMeter' &&
    !suppliesSpatialElement.includes(siteID)
  ) {
    return <img className="equipment-meter-icon" src={SubMeter} />;
  } else if (EEquipmentTypes === 'VirtualElectricMeter') {
    return <img className="equipment-meter-icon" src={VirtualMeter} />;
  } else {
    return <img className="equipment-meter-icon" src={SubMeter} />;
  }
};

export const isUndefinedOrNullCheck = (rowData: IAny) => {
  const type = rowData.types?.find(
    (val: string) => val === 'VirtualElectricMeter'
  );
  if (type === 'VirtualElectricMeter') {
    if (
      rowData.containsElementIds === undefined ||
      rowData.containsElementIds === null
    ) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};
